// extracted by mini-css-extract-plugin
export default {"trustBadge":"XPeUUxr2E6atMkvmbz5z"};